// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-02-04T11:45:05+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  191213
//    Project:        617
//    Environment:    7626 - master
//    MD5:            32fe3f917217b3d46bacc700f371322d
//    Signature:      eyJpdiI6IkhFcWJiVjkxcTRwYUFIeTY1dzV4TVE9PSIsInZhbHVlIjoiRlBHVk1FeGx6d1hZRnRpSUZ6dEl5eHNPMUFld0tZdWo3cCtwT0V0TCtVUmIyQm80SlhDNDV5aHdzdTBNUm1scVB4bkFyWEJJcTJGd254REJwMjVMNnF6OUpUcFhVYVlIT3lcLzN2RnlKbzNJNHJaWExRM1BmMXhnM2RTQWxlelk3MGV3Y2h3R3VDZyttV1VtMVI5TE9UMFdrUXliSDJGbTJFWHB5bG1PaTkrV3FiNXhwbEJzMnFcL00yRkpXUk1QZHNSZkZDcFNcL2VOcUVwTjRMcVI3NFBWM1h0c293UG9XS1wvN2Z1RFNZZHJZU1hZMys0NndGOUJWT2dXbHpsY1BEeXBnWkdRT3M5eG9qNVpPSE5IMXAzcWpYQ2NrYlNwWXljakVyamhkakRPRXArOHhBWDdrc1NWbFdrZjNoSkJJOSt1MlNlSkY3Vkd5RUR6V0pXK2RRc3M0ZzgrNHVWSFJITjRJdkQyMEtrVTFHd3BxSkk1Z2czRisxXC9GbngrOXRxWkVEV0hhZDR6NktZVm1vZXVMZkIybDFRPT0iLCJtYWMiOiIzNGZjMzBmMjMzODE0Mzg3ZTJhZDEyMTBiZTdmZmVhMzFkZjAxYTRjYjE0ODk1OGI2MDAyMDc0NGFjM2Q4Mzk5In0=
let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}
